import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatusService {

  constructor(private http: HttpClient) { }

  ReadDeviceStatusLog(params): Observable<any> {
    const body = (typeof params.from !== 'number' && typeof params.to !== 'number')
      ? {
          ...params,
          from: params.from.getTime() / 1000,
          to: params.to.getTime() / 1000
        }
      : { ...params };
    return this.http.post<any>(`${environment.apiIotUrl}/status/log`, body);
  }

  ReadDeviceStatusPeak(params): Observable<any> {
    const body = (typeof params.from !== 'number' && typeof params.to !== 'number')
      ? {
          ...params,
          from: params.from.getTime() / 1000,
          to: params.to.getTime() / 1000
        }
      : { ...params };
    return this.http.post<any>(`${environment.apiIotUrl}/status/peak`, body);
  }
}
